import { Stack } from "@mantine/core";
import ManualImport from "../../lists/import/manualImport/ManualImport";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../../stores/LanguageStore";

const BlacklistImportPage = () => {
  const lang = useLanguage((s) => s.language);
  const navigate = useNavigate();
  return (
    <Stack mt={24} flex={1} w={"80%"} mx={"auto"}>
      <ManualImport
        onFinish={(id) => navigate("/blacklists/" + id)}
        setActiveWindow={() => navigate("..")}
        isBlacklist
        isActive={"manual"}
      />
    </Stack>
  );
};

export default BlacklistImportPage;
